import React from 'react';

const SIZE_CLASSES = { sm: 'w-7 h-7 text-xs', md: 'w-9 h-9 text-sm', lg: 'w-12 h-12 text-base' };
const TONE_CLASSES = { light: 'bg-themePrimary', dark: 'bg-violet-600' };

const initials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const Avatar = ({ name, src, size = 'md', tone = 'light', className = '' }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name || 'avatar'}
        className={['rounded-full object-cover flex-shrink-0', SIZE_CLASSES[size], className].join(' ')}
      />
    );
  }
  return (
    <div
      className={[
        'rounded-full flex items-center justify-center font-semibold text-white flex-shrink-0',
        SIZE_CLASSES[size],
        TONE_CLASSES[tone],
        className,
      ].join(' ')}
    >
      {initials(name)}
    </div>
  );
};

export default Avatar;
